import React, {ReactNode, useState} from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import {INotifyChannel} from 'entities/notification';
import {userSelector, CreateGatedButton, ICreateGatedButtonProps} from 'entities/user';
import Table, {IColumn} from 'shared/ui/Table/Table';
import TableBox from 'shared/ui/Box/TableBox/TableBox';
import IOrderBy from 'shared/model/IOrderBy';
import {canCreateNotifyChannel, INotifyChannelApi} from 'features/profile/model/notifyChannelApi';

import NotificationLimitInfo from '../NotificationLimitInfo/NotificationLimitInfo';

import styles from './NotifyChannels.module.scss';

interface INotifyChannelSectionProps<T extends INotifyChannel> {
    api: INotifyChannelApi<T>,
    title: ReactNode,
    limit: number | undefined,
    firstColumn: IColumn,
    create: Pick<ICreateGatedButtonProps, 'label' | 'exceededType' | 'Modal'>,
    renderRow: (_item: T) => React.JSX.Element,
    mainItem?: {item: T, active: boolean},
    last?: boolean,
}

const NotifyChannelSection = <T extends INotifyChannel>({
    api,
    title,
    limit,
    firstColumn,
    create,
    renderRow,
    mainItem,
    last,
}: INotifyChannelSectionProps<T>) => {
    const [sort, setSort] = useState<IOrderBy>();
    const user = useSelector(userSelector);
    const {data: items, isLoading} = api.useGetListQuery(sort);
    const {data: activeItems} = api.useGetActiveQuery();

    const activeCount = activeItems?.length ?? 0;
    const mainCount = mainItem ? 1 : 0;
    const rows = mainItem && !isLoading ? [mainItem.item, ...(items ?? [])] : items;

    return (
        <TableBox className={cn(styles.container, last && styles.lastContainer)}>
            <div className={styles.head}>
                <div className={styles.headTitle}>
                    <h3>{title}</h3>
                    <NotificationLimitInfo
                        current={activeCount + (mainItem?.active ? 1 : 0)}
                        limit={(limit ?? 0) + mainCount}
                    />
                </div>
                <CreateGatedButton
                    {...create}
                    variant="transparent"
                    canCreate={canCreateNotifyChannel(user ? limit : undefined, activeItems?.length)}
                />
            </div>

            <Table
                columns={[
                    firstColumn,
                    {label: t`Описание`, sort: 'description'},
                    {label: t`Статус`, sort: 'active'},
                    {label: ''},
                    {label: ''},
                    {label: ''},
                ]}
                items={rows}
                rowFactory={renderRow}
                isLoading={isLoading}
                sort={sort}
                setSort={setSort}
            />
        </TableBox>
    );
};

export default NotifyChannelSection;
